import { useAccessResource } from "./useAccessResource";
import { creatorStreamAccessService } from "../services/creatorStreamAccessService";

export const useCreatorStreamAccess = (username, userId) =>
  useAccessResource(username, userId, creatorStreamAccessService);
